module.exports = __webpack_public_path__ + "static/media/feifengshan_mobile.0594f8a5.webp";